import { render, staticRenderFns } from "./examinerScriptDistribution.vue?vue&type=template&id=2005c596&"
import script from "./examinerScriptDistribution.vue?vue&type=script&lang=js&"
export * from "./examinerScriptDistribution.vue?vue&type=script&lang=js&"
import style0 from "./examinerScriptDistribution.vue?vue&type=style&index=0&id=2005c596&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports